export const CandidateCheckScreens = {
  REFERENCE: 'reference',
  CUSTOM_REFERENCE: 'custom_reference',
  QUESTIONNAIRE: 'questionnaire',
  DOCUMENT_SIGNING: 'document_signing',
  SUCCESS: 'success',
  // TODO: Remove this once the clients switched over to ACIC
  BACKY_PORTAL: 'backy_portal',
};
